const options = {
  5: "bg-orange-100/5",
  10: "bg-orange-100/10",
  25: "bg-orange-100/25",
  50: "bg-orange-100/50",
  75: "bg-orange-100/75",
  90: "bg-orange-100/90",
  100: "bg-orange-100",
};

const from = {
  5: "from-orange-100/5",
  10: "from-orange-100/10",
  25: "from-orange-100/25",
  50: "from-orange-100/50",
  75: "from-orange-100/75",
  90: "from-orange-100/90",
  100: "from-orange-100",
};

export default function getBackgroundOrange100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
